import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  text: {
    width: "100%",
    textAlign: "center",
    backgroundColor: "rgb(244, 92, 54)",
    color: "white",
    position: "fixed",
    zIndex: 1000000,
  },
}));

export default useStyles;
